import { countryTaxSystems } from './systems'
import type { TaxSystem } from '../../types/tax'

const DEFAULT_TAX_SYSTEM: TaxSystem = {
  name: 'GST',
  defaultRate: 15,
  country: 'New Zealand'
}

export const detectUserTaxSystem = (): TaxSystem => {
  try {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    for (const system of countryTaxSystems) {
      const matches = system.timezone.some((tz) => {
        if (tz.endsWith('/*')) {
          const region = tz.slice(0, -2)
          return userTimeZone.startsWith(region)
        }
        return tz === userTimeZone
      })

      if (matches) {
        return system.taxSystem
      }
    }

    return DEFAULT_TAX_SYSTEM
  } catch (error) {
    console.warn('Failed to detect tax system:', error)
    return DEFAULT_TAX_SYSTEM
  }
}
